import { atom } from "jotai";
import type { CategoryResponse } from "@models/category";

export const categoriesAtom = atom<CategoryResponse[]>([]);

export const isFetchingCategoriesAtom = atom<boolean>(false);

export const categoriesFetchErrorAtom = atom<boolean>(false);

export const isProcessingCategoriesAtom = atom<boolean>(false);
